import "@fancyapps/fancybox/dist/jquery.fancybox.min";

const staffPopup = () => {
	$(".staff-popup-js").fancybox({
		baseClass: "staff-view",
		infobar: false,
		buttons: false,
		thumbs: false,
		margin: 0,
		touch: {
			vertical: false,
		},
		scrolling: 'hidden',
		helpers: {
			overlay: {
				locked: true,
			},
		},
		loop: true,
		animationEffect: "slide",
		transitionEffect: "slide",
		transitionDuration: 600,
		baseTpl:
			'<div class="fancybox-container" role="dialog">' +
			'<div class="fancybox-bg"></div>' +
			'<div class="staff-view__content">' +
			'<div class="staff-view__img">' +
			'<div class="fancybox-stage"></div>' +
			"</div>" +
			'<div class="staff-view__aside">' +
			"</div>" +
			'<button data-fancybox-close class="staff-view__close"></button>' +
			"</div>" +
			"</div>",

		beforeShow: function (instance) {
			instance.$refs.container
				.find(".staff-view__aside")
				.addClass("staff-view__aside--close");
			// $("body").css({'overflow-y': 'hidden'});
		},
		beforeClose: function () {
			$("body").css({'overflow-y': 'initial'});
		},
		afterShow: function (instance) {
			let element = instance.group[instance.currIndex].opts.$orig;
			let form_id = element.data("staff-elem");

			instance.$refs.container
				.find(".staff-view__aside")
				.html(
					$("#" + form_id)
						.clone(true)
						.removeClass("visibility-hidden")
				)
				.removeClass("staff-view__aside--close")
				.addClass("staff-view__aside--open");

			$("body").css({'overflow-y': 'hidden'});
		},
	});
};

export default staffPopup;



// WEBPACK FOOTER //
// ./scripts/modules/staff-popup.js